// extracted by mini-css-extract-plugin
module.exports = {"row1":"buttonGroup_row1__UNYM1","row2":"buttonGroup_row2__CkEqd","pos2":"buttonGroup_pos2__sXO6n","centered":"buttonGroup_centered__VgdR5"};